import { extract } from 'query-string';
import {} from 'waypoints/lib/noframework.waypoints.js';
import {} from 'waypoints/lib/shortcuts/inview';

import { dDom } from '../../../core/js/utils/renderUtils';

import {
    setProductTileSwatchImage,
    setProductTileSwatchUrl,
    setProductTileActiveSwatch
 } from '../../../product/js/utils/tileUtils';
import {
    updateGridTileProduct
} from '../actions/tileControlsActions';

import { debug, warn } from '../utils/logger';

import { unveilImages } from '../uiSupport/unveil';

import template from 'category-grid.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';

import { createGAEvent } from '../../../core/js/utils/analyticsUtils';
import { handleUtagEvent } from '../actions/initialActions';
import { isElementVisibleInViewport } from '@core/js/utils/visibilityUtils';

function isVideoPlaying(videoTile) {
    return !videoTile.ended && !videoTile.paused;
}

// handling playing video in the way recommended by
// https://webkit.org/blog/7734/auto-play-policy-changes-for-macos/
function playVideo(videoElement) {
    const promise = videoElement.play();

    if (promise) {
        return promise.catch(err => {
            warn(`error playing video: ${err}`);
        });
    }

    return promise;
}

function playVideoTile(store, videoTile) {
    // if video is not playing, but is in the viewport, play it
    if (!isVideoPlaying(videoTile) && isElementVisibleInViewport(videoTile)) {
        if($(videoTile).hasClass('js-playable-tile-video')) {

            $(videoTile).removeClass('c-product-tile-controls__video-wrap--hidden');

            if(videoTile.timeupdate || videoTile.ended) {
                videoTile.currentTime = 0;
                playVideo(videoTile);
            } else {
                playVideo(videoTile);
            }

            const videoId = videoTile.getAttribute('data-video-id');
            if(!_.isNil(videoId)) {
                const gaEvent = createGAEvent('category', 'video|autoplay', videoId,
                    { 'dy_noninteraction': true });
                store.dispatch(handleUtagEvent(gaEvent, 'link', null));
            }
        }
    }
}

function createWaypointEnterCallback(store, videoTile) {
    return function waypointEnter(direction) {
        playVideoTile(store, videoTile);
    };
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.js-category-grid',
        watch: 'category.catalogRequestUrl',
        name: 'gridComponent',
        onStateChange: onStateChange,
        attachEvents: attachEvents,
        template: template,
        renderType: dDom,
        changeSwatch: changeSwatch,
        displayVideoIconBadge: displayVideoIconBadge,
        getProduct: getProduct,
        afterRender: afterRender,
        afterConstruction: afterConstruction,
        videoTileWaypoints: [],
        bindVideoTile: bindVideoTile
    };
    return generate(config, store, overrides, getDefaultOptions(store));
}

export function bindVideoTile() {
    const gridVideoTiles = $('.js-product-tile-video');

    _.forEach(this.videoTileWaypoints, (waypoint) => {
        waypoint.destroy();
    });

    this.videoTileWaypoints = [];
    const store = this.store;

    _.forEach(gridVideoTiles, (videoTile) => {
        this.videoTileWaypoints.push(new Waypoint.Inview({ // eslint-disable-line no-undef
            element: videoTile,
            enter: createWaypointEnterCallback(store, videoTile),
            exited: function waypointExited(direction) {
                if($(videoTile).hasClass('js-playable-tile-video')) {
                    videoTile.pause();
                }
            }
        }));

        $(videoTile).bind('ended', function videoTileEnded() {
            $(this).addClass('c-product-tile-controls__video-wrap--hidden');
        });

        $(videoTile).bind('timeupdate', function videoTileTimeUpdated() {
            const isHovered = this.classList.contains('is-hovered');

            if(this.currentTime >= 5 && !isHovered) {
                this.pause();
                $(this).addClass('c-product-tile-controls__video-wrap--hidden');
                this.currentTime = 0;
            }
        });
    });
}

export function afterConstruction() {
    const state = this.store.getState();

    if(_.get(state, 'category.hasVideoTiles')) {
        this.bindVideoTile();
    }
}

export function afterRender() {
    unveilImages($('.js-lazy'));

    const state = this.store.getState();

    if(_.get(state, 'category.hasVideoTiles')) {
        this.bindVideoTile();
    }
}

export function addLoader() {
    // $('.js-category-grid').addClass('s-category-grid--semi-loading');
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */

export function onStateChange(store, watchValue, oldVal, newVal) {
    if(oldVal) {
        debug('core.routeInfo has updated, update grid');
        this.render(store, this, {});
    }
}

export function attachEvents(store) {
    unveilImages($('.js-lazy'));
    $(document).on(this.scopedEvent('touchend click'), '.js-product-tile-control-quickshop', (e) => {
        e.preventDefault();
    });

    $(document).on(this.scopedEvent('touchend click'), '.js-category-grid .js-swatch-link-category', (e) => {
        e.preventDefault();
        this.changeSwatch(store, e);
        this.displayVideoIconBadge(e);
    });

    // When mouse moves into product tile, add hover class - if not mobile or tablet
    const isTouchDevice = _.get(this.getDeviceCharacteristics(), 'is_touch', false);

    if(!isTouchDevice) {
        $(document).on('mouseenter', '.js-product-tile-video-wrap', (e) => {
            if($(e.currentTarget).find('.js-playable-tile-video').length) {
                handleVideoTileHover(e, store);
            }
        });

        $(document).on('mouseleave', '.js-product-tile-video-wrap', (e) => {
            if($(e.currentTarget).find('.js-playable-tile-video').length) {
                handleVideoTileHoverOut(e, store);
            }
        });
    }

    // Disable touch & click events on grid tiles and their child elements while loading is in progress
    $(document).on(this.scopedEvent('touchend click'), '.s-category-grid--semi-loading', (e) => {
        return false;
    });
}

/**
 * Handles the hoverstate of a video tile
 * Removes the class to hide the video
 * Begins to play the video and adds the loop attribute so it will play continuously while user is hovered.
 * @param  {object} e     The event object
 * @param  {object} store The current state of the redux store
 */
export function handleVideoTileHover(e, store) {
    const element = e.currentTarget;
    const video = element.querySelector("video");

    $(video).removeClass('c-product-tile-controls__video-wrap--hidden');
    $(video).addClass('is-hovered');
    playVideo(video);
    video.loop = "loop";

    const videoId = $(e.currentTarget).find('video')
                                      .attr('data-video-id');
    if (!_.isNil(videoId)) {
        const gaEvent = createGAEvent('category', 'video|onhover', videoId);
        store.dispatch(handleUtagEvent(gaEvent, 'link'));
    }
}

/**
 * Handles the hover removal of a video tile
 * Pauses the video and resets the time to start at the beginning if hover is ever reinitiated.
 * Removes the loop attribute.
 * Handles class removal/addition to hide the video.
 * @param  {object} e     The event object
 */
export function handleVideoTileHoverOut(e) {
    const element = e.currentTarget;
    const video = element.querySelector("video");

    video.pause();
    video.currentTime = 0;
    video.loop = "";
    $(video).addClass('c-product-tile-controls__video-wrap--hidden');
    $(video).removeClass('is-hovered');
}

/*
 * Get a product from the store
 */
function getProduct(store, productIndex) {
    return store.getState().category.products.records[productIndex];
}

/*
 * Change a product swatch on a product in the component
 */
function changeSwatch(store, e) {
    // Index within the grid
    const productTile = $(e.target).parents('.js-product-tile');
    const productIndex = productTile.attr('data-product-index');

    const newUrl = setProductTileSwatchUrl(e);
    setProductTileSwatchImage(store, e);
    setProductTileActiveSwatch(e);

    const product = this.getProduct(store, productIndex);
    product.allMeta.tile.product.queryParams = extract(newUrl);

    store.dispatch(updateGridTileProduct(productIndex, product));
}

function displayVideoIconBadge(e) {
    const $el = $(e.currentTarget);
    const displayVideoIconForTile = !_.isUndefined($el.attr('data-has-video'));
    $el.closest('.js-product-tile')
        .find('.js-product-tile-video')
        .toggleClass('is-visible', displayVideoIconForTile);
}
